import { darken } from '@mui/material'
import { Button } from 'reactstrap'
import styled from 'styled-components'

export const ContentFiltros = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  & .tags-dropdown {
    position: absolute;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 0 8px 8px;
    z-index: 1000;
    min-width: 220px;
    max-height: 200px;
    overflow-y: auto;
  }

  & .tags-dropdown p {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
    position: sticky;
    top: 0;
    background-color: white;
    padding: 8px;
    &::after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: #ddd;
    }
  }

  & .tags-dropdown div {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  & .btn-filtro {
    background: none;
    border: none;
    box-shadow: none;
    padding: 0;
    margin: 0;
    font: inherit;
    color: inherit;
    cursor: pointer;

    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 10px;
    border-radius: 8px;
    border: 1px solid #ddd;
    font-weight: 500;

    &:hover {
      background-color: #f0f0f0;
    }

    &.active {
      background-color: #cecece;
    }
  }
`

export const BoardContainer = styled.div`
  padding: 5px;

  & .react-kanban-column {
    display: flex;
    flex-direction: column;
    font-family: ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji',
      'Segoe UI Emoji', Segoe UI Symbol, 'Noto Color Emoji';
    gap: 10px;
    padding: 0px;
    background-color: rgba(240, 242, 244, 0.1);
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    border: 1px solid #ddd;
  }
`

interface CardContainerProps {
  borderColor?: string
}
export const CardContainer = styled.div<CardContainerProps>`
  position: relative;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  padding: 12px;
  margin: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  border-left: 4px solid ${(props) => props.borderColor || '#4caf50'};
  min-width: 300px;

  &:hover .action-buttons-container {
    display: flex;
  }
`

export const ActionButtonsContainer = styled.div`
  display: none;
  justify-content: space-around;
  align-items: center;
  margin-top: 10px;
  padding: 8px;
  border-top: 1px solid #ddd;
`

export const ActionButton = styled(Button)`
  background-color: transparent;
  border: solid 1px #ddd;
  border-radius: 12px;
  color: #000;
  font-size: 12px;
  padding: 4px 8px;
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Avatar = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #e8f5e9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`

export const CardTitle = styled.div`
  font-weight: 700;
  font-size: 12px;
`

interface CardTagProps {
  color?: string
}
export const CardTag = styled.span<CardTagProps>`
  background-color: transparent;
  color: ${(props) => props.color || '#1976d2'};
  border: 1px solid ${(props) => props.color || '#1976d2'};
  font-size: 11px;
  font-weight: 600;
  padding: 2px;
  border-radius: 10px;
  margin-left: 4px;
  width: fit-content;
`

const getAdjustedColor = (backgroundColor: string): string => {
  const brightness = parseInt(backgroundColor.replace('#', ''), 16)

  if (brightness < 0x7f7f7f) {
    return '#fff'
  }

  return darken(backgroundColor, 0.6)
}

interface CardBadgeProps {
  color?: string
}

export const CardBadge = styled.span<CardBadgeProps>`
  background-color: ${(props) => props.color || '#ffcdd2'};
  color: ${(props) => getAdjustedColor(props.color || '#ffcdd2')};
  border: 1px solid ${(props) => darken(props.color || '#ffcdd2', 0.6)};
  font-size: 12px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 12px;
`

export const CardInfo = styled.span`
  color: #646e82;
  font-size: 0.825rem;
`

export const CardValue = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #000;
`

export const CardTime = styled.span`
  color: #777;
  font-size: 0.825rem;
`

export const ColumnHeader = styled.div`
  padding: 10px;
  border-radius: 8px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #ddd;
  }
`

export const ColumnTitle = styled.span`
  font-size: 14px;
`
